import gql from 'graphql-tag'

export const REGISTER_COMPANY_MUTATION = gql`
  mutation registerCompanyMutation(
    $company: CompanyInput!
    $administrator: CreateAdministratorInput!
  ) {
    registerCompany(company: $company, administrator: $administrator) {
      token
    }
  }
`
